import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { ScholarshipProviderType } from "../../types/ScholarshipProviderType";
import { get, post, put } from "../../utils/axios-config";
import { SCHOLARSHIP_PROVIDERS } from "../../utils/constants";

export const createScholarshipProvider = async (data: ScholarshipProviderType) => 
    await post(SCHOLARSHIP_PROVIDERS, data);

export const getScholarshipProviders = async (data: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || "1",
        PageSize: data?.PageSize?.toString() || "100",
    });
    return await get<PagedResultsType<ScholarshipProviderType>>(`${SCHOLARSHIP_PROVIDERS}?${queryParams.toString()}`);
};

export const updateScholarshipProvider = async (data: ScholarshipProviderType) => 
    await put(SCHOLARSHIP_PROVIDERS, data);

// export const deleteScholarshipProvider = async (id: string) => 
//     await del(`${SCHOLARSHIP_PROVIDERS}/${id}`, {});
